/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const Loader: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 64 64" size={size} color={color} {...props}>
      <path d="M32 2.4c0-1.325 1.076-2.41 2.398-2.31a32 32 0 11-19.214 59.135c-1.128-.696-1.361-2.206-.582-3.278s2.275-1.3 3.412-.619a27.198 27.198 0 0040.851-27.583 27.2 27.2 0 00-24.468-22.84C33.077 4.79 32 3.726 32 2.4z" />
    </Icon>
  );
};

export default Loader;

Loader.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
